import Chart from "react-apexcharts";
import { colors } from "../../global";

const ActivityByMonth = ({ data }) => {
  if (!data || !data.categories) return null;
  const chartColors = [
    colors.primary,
    colors.accent,
    colors.tertiary,
    "#FF9800",
    "#4CAF50",
    "#9C27B0",
  ];

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">
        Activities by Type per Month
      </h2>
      <Chart
        options={{
          chart: { type: "line", toolbar: { show: false } },
          stroke: { curve: "smooth", width: 3 },
          xaxis: {
            categories: data.categories, 
            title: { text: "Activity Type" },
            labels: { rotate: -25, style: { fontSize: "12px" } },
          },
          yaxis: {
            title: { text: "Total Activities" },
            labels: { formatter: (v) => Math.round(v) },
          },
          legend: {
            position: "top",
            horizontalAlign: "center",
            fontSize: "13px",
            markers: { radius: 4 },
          },
          colors: chartColors.slice(0, data.series.length), 
          markers: { size: 4 },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: (v) => `${Math.round(v).toLocaleString()} activities`,
            },
          },
          dataLabels: {
            enabled: true,
            formatter: (v) => Math.round(v).toLocaleString(),
            offsetY: -10,
            style: { fontSize: "12px", fontWeight: "bold" },
            background: {
              enabled: true,
              foreColor: "#fff",
              borderRadius: 4,
              padding: 4,
              opacity: 0.8,
            },
          },
        }}
        series={data.series}
        type="line"
        height={350}
      />
    </>
  );
};

export default ActivityByMonth;
